import axios from 'axios';

import router from '@/router';
import auth from '@/utils/auth';

import {
  DELETE_USER,
  DELETE_USER_ERROR,
  DELETE_USER_SUCCESS,

  GET_USER,
  GET_USER_ERROR,
  GET_USER_SUCCESS,

  GET_USERS,
  GET_USERS_ERROR,
  GET_USERS_SUCCESS,

  SEARCH_USERS,
  SEARCH_USERS_ERROR,
  SEARCH_USERS_SUCCESS,

  SAVE_USER,
  SAVE_USER_ERROR,
  SAVE_USER_SUCCESS,

  SAVE_PASSWORD,
  SAVE_PASSWORD_ERROR,
  SAVE_PASSWORD_SUCCESS,

  SAVE_USER_SIMPLE,
  SAVE_USER_SIMPLE_ERROR,
  SAVE_USER_SIMPLE_SUCCESS,

  GET_BOARD_MEMBER,
  GET_BOARD_MEMBER_ERROR,
  GET_BOARD_MEMBER_SUCCESS,
} from './constants';

export default {
  async [DELETE_USER]({ commit }, userID) {
    try {
      commit(DELETE_USER);
      await axios({
        url: `${process.env.API_URL}/api/users/${userID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_USER_SUCCESS);
      router.push({ name: 'User Listing' });
    } catch (err) {
      commit(DELETE_USER_ERROR, err);
    }
  },

  async [GET_USER]({ commit }, userID) {
    try {
      commit(GET_USER);
      const response = await axios({
        url: `${process.env.API_URL}/api/users/${userID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_USER_SUCCESS, response.data);
    } catch (err) {
      commit(GET_USER_ERROR, err);
    }
  },

  async [GET_USERS]({ commit }, args) {
    try {
      commit(GET_USERS);
      const response = await axios({
        url: `${process.env.API_URL}/api/users`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          filters: args.filters || null,
        },
      });
      commit(GET_USERS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_USERS_ERROR, err);
    }
  },

  async [GET_BOARD_MEMBER]({ commit }, syndicateID) {
    try {
      commit(GET_BOARD_MEMBER);
      const response = await axios({
        url: `${process.env.API_URL}/api/${syndicateID}/board-members`,
        method: 'GET',
        headers: auth.getAuthHeader(),

      });
      commit(GET_BOARD_MEMBER_SUCCESS, response.data);
    } catch (err) {
      commit(GET_BOARD_MEMBER_ERROR, err);
    }
  },

  async [SEARCH_USERS]({ commit }, args) {
    try {
      commit(SEARCH_USERS);
      const response = await axios({
        url: `${process.env.API_URL}/api/users`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          filters: args.filters || null,
        },
      });
      commit(SEARCH_USERS_SUCCESS, response.data);
    } catch (err) {
      commit(SEARCH_USERS_ERROR, err);
    }
  },

  async [SAVE_USER]({ commit }, data) {
    try {
      commit(SAVE_USER);
      let url = `${process.env.API_URL}/api/users`;
      let method = 'POST';
      if (data.userID) {
        url = `${url}/${data.userID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_USER_SUCCESS, response.data);
      if (method === 'POST') {
        router.push({ name: 'Edit User', params: { userID: response.data.userID } });
      }
    } catch (err) {
      commit(SAVE_USER_ERROR, err);
    }
  },

  async [SAVE_PASSWORD]({ commit }, data) {
    try {
      commit(SAVE_PASSWORD);
      const response = await axios({
        url: `${process.env.API_URL}/api/users/${data.userID}/password`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_PASSWORD_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_PASSWORD_ERROR, err.response.data);
    }
  },

  async [SAVE_USER_SIMPLE]({ commit }, data) {
    try {
      commit(SAVE_USER);
      const url = `${process.env.API_URL}/api/users`;
      const method = 'POST';
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_USER_SIMPLE_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_USER_SIMPLE_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Users/actions.js